export default __webpack_public_path__ + "static/petiteMaro.range-978730c514ed27e876a9b78fd1228999.jpg";